import { CaseState } from "us.collection.transactions/constants";
import { ICase, ISubCase } from "us.collection.transactions/interfaces";
import { appInsights } from "us.helper";
import { CaseType } from "us.helper/types/enums";

/**
 * @function
 * @description - To get the data arranged for the manage case grid
 * @param {ICase[]} caseList - list of all the cases
 * @param {ICase[]} selectedCases - list of cases selected in the Home view
 * @return {*}  {ISubCase[]} - filtered list of sub cases
 */
export const getDataArranged = (
  caseList: ICase[],
  selectedCases: ICase[]
): ISubCase[] => {
  try {
    let filteredCaseList = [...caseList];
    const isSelectOnlyOneParentCase =
      selectedCases.length === 1 &&
      selectedCases[0].caseType === CaseType.C &&
      selectedCases[0].parentId > 0;
    if (isSelectOnlyOneParentCase) {
      const selectedId = selectedCases[0].caseId;
      filteredCaseList = filteredCaseList.filter(
        (caseItem) => caseItem.caseId !== selectedId
      );
    }

    const hasAdditionalRefSelectedCases = selectedCases.some(
      (caseItem) =>
        caseItem.additionalReference1 || caseItem.additionalReference2
    );
    if (hasAdditionalRefSelectedCases) {
      filteredCaseList = filteredCaseList.filter((caseItem) =>
        selectedCases.some(
          (sc) =>
            sc.additionalReference1 === caseItem.additionalReference1 &&
            sc.additionalReference2 === caseItem.additionalReference2 &&
            sc.additionalReference3 === caseItem.additionalReference3
        )
      );
    } else {
      filteredCaseList = filteredCaseList.filter(
        (caseItem) =>
          !caseItem.additionalReference1 && !caseItem.additionalReference2
      );
    }

    return filteredCaseList
      .filter(
        (rowCase) =>
          rowCase.caseState === CaseState.OPEN &&
          rowCase.caseType === CaseType.C &&
          rowCase.isMergeEnabled
      )
      .map(({ ...item }: any) => {
        delete item.children;
        return item;
      });
  } catch (error) {
    appInsights.trackException(
      `Error in add case and subcases drawerStatusHandler function. - ${error}`
    );
    return [];
  }
};
